
// constant
import { host } from "../../../assets/constants/host";

export const apiGetTransactionDetails = `${host}/backoffice/get-transaction-detail`